import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCustomControl } from "../contexts/customControlContextFactory.js";
import "../style/controls/rangeInput.scss";
const RangeInput = ()=>{
    const { value, setValue, params: { unit, inputAttrs } } = useCustomControl();
    const handleChange = (e)=>{
        setValue(+e.target.value);
    };
    const inputCommonAttributes = {
        ...inputAttrs,
        value,
        onChange: handleChange
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("input", {
                type: "range",
                ...inputCommonAttributes
            }),
            /*#__PURE__*/ _jsx("div", {
                "data-unit": unit || undefined,
                children: /*#__PURE__*/ _jsx("input", {
                    type: "number",
                    ...inputCommonAttributes
                })
            })
        ]
    });
};
export { RangeInput };
